import registrationStatusMapper from '../helpers/registrationStatusMapper';
import { getRegistrationStatusClass } from '../helpers/getRegistrationStatusClass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonGolfing } from '@fortawesome/pro-regular-svg-icons';

import styles from '../PlayerPortalsOnSiteRegistrationAdminPanel.module.scss';

type ParticipantCardProps = {
  name: string;
  registrationStatus: number;
  caddieName?: string;
  handleCardClick?: () => void;
};

export const ParticipantCard = ({
  name,
  registrationStatus,
  caddieName,
  handleCardClick,
}: ParticipantCardProps) => {
  const registrationStatusClass =
    getRegistrationStatusClass(registrationStatus);

  return (
    <div className={styles.card} onClick={handleCardClick}>
      <span className={styles.name}>{name}</span>

      {caddieName && (
        <div>
          <FontAwesomeIcon icon={faPersonGolfing} />{' '}
          <span className={styles.linkedPlayer}>{caddieName}</span>
        </div>
      )}

      <span
        className={`${styles.registrationStatus} ${registrationStatusClass}`}
      >
        {registrationStatusMapper.registrationStatus[registrationStatus]}
      </span>
    </div>
  );
};

export default ParticipantCard;
